module.exports = __webpack_public_path__ + "static/media/sologo.08fe4280.png";